import { debounce } from "lodash";
import React, { FC, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { Form, actions } from "react-redux-form";
import { useParams } from "react-router";
import Alert from "react-s-alert";
import ReactTable, { RowInfo } from "react-table";
import Button from "reactstrap/lib/Button";
import { bindActionCreators } from "redux";
import * as HrecActions from "../../../actions/hrec";
import * as InstitutionActions from "../../../actions/institution";
import * as NavigationActions from "../../../actions/navigation";
import * as ToggleActions from "../../../actions/pages/togglePage";
import * as TrialActions from "../../../actions/trial";
import { InlineLoading, NotificationAlert } from "../../../components/common";
import {
    CheckboxFormInput,
    SelectFormInput,
    TextAreaFormInput,
    TextFormInput,
} from "../../../components/form";
import { RestrictedLayout } from "../../../components/layouts";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../constants/fontAwesomeIcons";
import { PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import { createPersonnelSearchLoader } from "../../../functions/personnel";
import { renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import * as AuthenticationHelper from "../../../helpers/authentication";
import { HrecCreateBreadcrumbs, HrecDetailsBreadcrumbs } from "../../../helpers/breadcrumbHelper";
import { RegistrationComponent, renderFormControls } from "../../../helpers/formHelper";
import { findLookup, generateOptionsFromLookup } from "../../../helpers/lookupHelper";
import { HrecSubMenu } from "../../../helpers/subMenuHelper";
import * as ToggleHelper from "../../../helpers/toggleHelper";
import useNavigate from "../../../hooks/useNavigate";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers";
import { TogglePageItem } from "../../../reducers/pages/togglePage";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms";
import { IHrecReduxFormState } from "../../../reducers/reactReduxForms/hrec";

import "./HrecPage.scss";

const tableGeneralHeaderClassHrec = "btn btn-secondary btn-block rounded-0 p-3 d-flex";
const tableStyleClassHrec: React.CSSProperties = {
    textAlign: "left",
    fontWeight: "bold",
    color: "white",
    cursor: "pointer",
};

const reduxFormName: string = "reduxForms.hrec";

interface HrecPageProps {
    form: Dtos.Hrec & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: IHrecReduxFormState;
    hrec: Dtos.Hrec;
    lookups: Dtos.Lookup[];
    loadingHrec: boolean;
    loadHrecSuccess: boolean;
    loadHrecFailure: boolean;
    loadHrecErrorCode: string;
    savingHrec: boolean;
    saveHrecSuccess: boolean;
    saveHrecFailure: boolean;
    creatingHrec: boolean;
    createHrecSuccess: boolean;
    createHrecFailure: boolean;
    validatingHrec: boolean;
    validationFailures: Dtos.ResponseError[];
    permissions?: Dtos.PersonnelTmdPermissions[];
    toggleItems: TogglePageItem[];
    trials: Dtos.Trial[];
    loadingTrials: boolean;
    loadTrialsFailure: boolean;
    loadTrialsErrorCode: string;
    institutions: Dtos.Institution[];
    loadingInstitutions: boolean;
    loadInstitutionsFailure: boolean;
    loadInstitutionsErrorCode: string;
    clearHrec: HrecActions.IHrecClearActionCreator;
    loadHrec: HrecActions.IHrecLoadByIdActionCreator;
    saveHrec: HrecActions.IHrecSaveActionCreator;
    createHrec: HrecActions.IHrecCreateActionCreator;
    validateHrec: HrecActions.IHrecValidateActionCreator;
    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;
    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;
    toggleExpand: ToggleActions.IToggleExpandedStateActionCreator;
    clearTrials: TrialActions.ITrialClearActionCreator;
    loadTrials: TrialActions.ITrialLoadActionCreator;
    clearInstitutions: InstitutionActions.IInstitutionClearActionCreator;
    loadInstitutions: InstitutionActions.IInstitutionLoadActionCreator;
}

const HrecPage: FC<HrecPageProps> = ({
    form,
    formState,
    formProperties,
    //reduxFormState,
    hrec,
    lookups,
    loadingHrec,
    //loadHrecSuccess,
    loadHrecFailure,
    loadHrecErrorCode,
    savingHrec,
    saveHrecSuccess,
    saveHrecFailure,
    creatingHrec,
    //createHrecSuccess,
    //createHrecFailure,
    validatingHrec,
    validationFailures,
    permissions,
    toggleItems,
    trials,
    loadingTrials,
    loadTrialsFailure,
    loadTrialsErrorCode,
    institutions,
    loadingInstitutions,
    loadInstitutionsFailure,
    loadInstitutionsErrorCode,
    clearHrec,
    loadHrec,
    saveHrec,
    createHrec,
    validateHrec,
    loadForm,
    changeForm,
    resetForm,
    setBreadcrumbs,
    setDrawerItems,
    toggleExpand,
    clearTrials,
    loadTrials,
    clearInstitutions,
    loadInstitutions
}) => {
    //
    // -- Params --
    const { hrecId } = useParams<{ hrecId: string }>();
    const hrecIdNumber = parseInt(hrecId, 10);

    //
    // -- Hooks --
    const navigate = useNavigate();

    //
    // -- States --
    const [saveAndReturn, setSaveAndReturn] = useState<boolean>(false);
    const [initalised, setInitalised] = useState<boolean>(false);
    const [hasBeenSubmitted, setHasBeenSubmitted] = useState<boolean>(false);

    const loadReduxForm = () => {
        let extraData: Dtos.Hrec = {} as Dtos.Hrec;

        loadForm(reduxFormName, Object.assign({ ...hrec }, extraData));
    };


    // Load hrec
    useEffect(() => {
        if (hrecIdNumber && !hrec && !loadingHrec) {
            setDrawerItems(HrecSubMenu(hrecIdNumber, permissions));
            setBreadcrumbs(HrecDetailsBreadcrumbs(hrecIdNumber));

            loadHrec(hrecIdNumber);
            loadTrials();
            loadInstitutions();
        } else if (!hrecIdNumber && !hrec && !creatingHrec) {
            createHrec();
            setDrawerItems([]);
            setBreadcrumbs(HrecCreateBreadcrumbs());
        } else if (hrec && !initalised) {
            loadReduxForm();
            setInitalised(true);
        }
    }, [
        hrecIdNumber,
        hrec,
        loadingHrec,
        permissions,
        creatingHrec,
        initalised
    ]);

    // Navigate to error page on load failure
    useEffect(() => {
        if (loadHrecFailure) {
            navigate(`/error/${loadHrecErrorCode}`);
        }
        if (loadTrialsFailure) {
            navigate(`/error/${loadTrialsErrorCode}`);
        }
        if (loadInstitutionsFailure) {
            navigate(`/error/${loadInstitutionsErrorCode}`);
        }
    }, [
        loadHrecFailure, 
        loadHrecErrorCode,
        loadTrialsFailure,
        loadTrialsErrorCode,
        loadInstitutionsFailure,
        loadInstitutionsErrorCode
    ]);

    // Update breadcrumbs
    useEffect(() => {
        if (hrecIdNumber && hrec) {
            setBreadcrumbs(HrecDetailsBreadcrumbs(hrecIdNumber, hrec.fullName));
        }
    }, [hrecIdNumber, hrec]);

    // Reload hrec after saving
    useEffect(() => {
        if (!savingHrec && saveHrecSuccess) {
            Alert.success(
                <NotificationAlert
                    alertContent={<span>HREC saved successfully</span>}
                    icon={FontAwesomeIcons.Solid.CHECK}
                />
            );

            if (saveAndReturn) {
                navigate("/settings/hrecs");
            } 
            else if (!hrecIdNumber) {
                navigate(`/settings/hrecs/${hrec.id}/details`);
                clearHrec();
            }
        }
    }, [
        savingHrec,
        saveHrecSuccess,
        saveAndReturn,
        hrecIdNumber,
        hrec
    ]);

    // Failed saving
    useEffect(() => {
        if (!savingHrec && saveHrecFailure) {
            Alert.error(
                <NotificationAlert
                    alertContent={renderRegistrationFormSaveBlock()}
                    icon={FontAwesomeIcons.Solid.BAN}
                />
            );
        }
    }, [savingHrec, saveHrecFailure]);

    // Cleanup effect to clear the hrec on component unmount
    useEffect(() => {
        return () => {
            clearHrec();
            clearInstitutions();
            clearTrials();
            resetForm(reduxFormName);
        };
    }, [
        clearHrec, 
        clearInstitutions,
        clearTrials,
        resetForm, 
        reduxFormName
    ]);

    const onCancel = () => {
        navigate("/settings/hrecs");
    };

    const handleOnSubmitFailed = (_data: Dtos.Hrec) => {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    };

    const handleOnSubmit = async (data: any) => {
        if (!hasBeenSubmitted) {
            setHasBeenSubmitted(true);
        }

        if (data) {
            let changes: Dtos.Hrec = {} as Dtos.Hrec;

            await saveHrec(Object.assign({ ...data }, changes));

            if (data.saveAndReturn) {
                setSaveAndReturn(true);
            }
        }
    };

    // Debounce validation after the initial submit to clear form validation errors as the form get updated.
    useEffect(() => {
        const debounceValidate = debounce(async () => {
            let changes: Dtos.Hrec = {} as Dtos.Hrec;

            if (form && hasBeenSubmitted && !validatingHrec) {
                await validateHrec(Object.assign({ ...form }, changes));
            }
        }, 250);

        debounceValidate();

        return () => {
            debounceValidate.cancel();
        };
    }, [form]);

    const personnelSearchLoader = useMemo(() => {
        return createPersonnelSearchLoader(
            form?.administrator 
                ? { label: form?.administrator?.displayWithSalutation, value: form?.administratorId } as Dtos.PersonnelOption 
                : null
        );
    }, [form]);

    const renderTrialsAndInstitutions = useMemo(() => {
        const showPagination = false;
        if (loadingInstitutions || loadingTrials) {
            return (
                <div className="d-flex w-100 justify-content-center pb-3">
                    <InlineLoading size={34} text={""} absoluteCenter={false} />
                </div>
            );
        }

        if (
            hrec == undefined ||
            hrec?.trialInstitutions == undefined ||
            hrec?.trialInstitutions?.length == 0
        ) {
            return (
                <div className="alert alert-info d-flex mb-4">
                    <div className="mr-2">
                        <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                    </div>
                    <span>No Trials or Institutions are associated with this HREC.</span>
                </div>
            );
        }

        let uniqueTrialIds: number[] = [
            ...new Set(hrec.trialInstitutions?.map((x) => x.trialId)),
        ];

        return (
            <div>
                {uniqueTrialIds?.map((trialId, index) => {
                    const key = `trial-institution-list-${hrecIdNumber}-${trialId}-${index}`;
                    const expanded = !ToggleHelper.isToggleExpanded(toggleItems, key);
                    const trialInstitutionsIds = hrec.trialInstitutions
                        ?.filter((x) => x.trialId === trialId)
                        ?.map((x) => x.institutionId);
                    const currentInstitutions = institutions?.filter((x) => trialInstitutionsIds?.includes(x.id));
                    const currentTrial = trials?.find((x) => x.id == trialId);

                    return (
                        <div key={key} className="mb-4">
                            <div
                                className={tableGeneralHeaderClassHrec}
                                style={tableStyleClassHrec}
                                onClick={() => toggleExpand(key)}
                            >
                                <div>
                                    <FontAwesomeIcon
                                        icon={
                                            !expanded
                                                ? FontAwesomeIcons.Solid.ANGLE_DOWN
                                                : FontAwesomeIcons.Solid.ANGLE_UP
                                        }
                                        fixedWidth
                                        transform="grow-16"
                                        className="mr-3"
                                    />
                                </div>
                                <span>
                                    {currentTrial?.displayName ??
                                        currentTrial?.display ??
                                        currentTrial?.protocolID}
                                </span>
                            </div>
                            {expanded && (
                                <ReactTable
                                    data={currentInstitutions}
                                    pageSizeOptions={PAGE_SIZE_OPTIONS}
                                    defaultPageSize={currentInstitutions.length}
                                    pageSize={currentInstitutions.length}
                                    showPagination={showPagination}
                                    className="-striped -highlight -clickable"
                                    noDataText="There are currently no institutions for this trial"
                                    resizable={false}
                                    defaultSorted={[
                                        {
                                            id: "name",
                                            desc: false,
                                        },
                                    ]}
                                    getTdProps={(
                                        state,
                                        rowInfo: RowInfo,
                                        _column,
                                        _instance
                                    ) => {
                                        return {
                                            onClick: (e, handleOriginal) => {
                                                navigate(`/trials/${trialId}/trialinstitution/${rowInfo.original.id}/details`);

                                                if (handleOriginal) {
                                                    handleOriginal();
                                                }
                                            },
                                        };
                                    }}
                                    columns={[
                                        {
                                            id: "id",
                                            Header: " ",
                                            accessor: "id",
                                            maxWidth: 50,
                                            Cell: (_props) => (
                                                <FontAwesomeIcon
                                                    size="lg"
                                                    icon={FontAwesomeIcons.Duotone.INSTITUTION}
                                                    fixedWidth
                                                />
                                            ),
                                        },
                                        {
                                            id: "name",
                                            Header: "Institution",
                                            accessor: "name",
                                        },
                                    ]}
                                />
                            )}
                        </div>
                    );
                })}
            </div>
        );
    }, [
        loadingInstitutions,
        loadingTrials,
        hrec,
        hrecIdNumber,
        toggleItems,
        institutions,
        trials,
        tableGeneralHeaderClassHrec,
        tableStyleClassHrec,
        toggleExpand,
        PAGE_SIZE_OPTIONS,
        navigate
    ]);

    const renderContent = useMemo(() => {
        const canViewDetails = AuthenticationHelper.hasPermission(
            permissions,
            Dtos.Permission.HrecDetailsView,
            hrecIdNumber,
            undefined
        );
        const hasPermission: boolean =
            AuthenticationHelper.hasCreateEditPermissionFor(
                hrecIdNumber,
                undefined,
                permissions,
                Dtos.Permission.HrecUpdate,
                Dtos.Permission.HrecCreate
            );
        const formDisabled: boolean =
            !hasPermission ||
            savingHrec ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            details: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <h1>Details</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "hrec",
                                        {
                                            fullName: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-1",
                                                fieldClassName: "col-sm-11 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "hrec",
                                        {
                                            shortName: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-2",
                                                fieldClassName: "col-sm-8 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "hrec",
                                        {
                                            hrecNo: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-3",
                                                fieldClassName: "col-sm-9 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "hrec",
                                        {
                                            website: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-1",
                                                fieldClassName: "col-sm-11 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "hrec",
                                        {
                                            entityName: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextAreaFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-1",
                                                fieldClassName: "col-sm-11 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row pt-2 pb-4 px-4">
                                <div className="col-sm-12">
                                    {renderFormControls(
                                        form,
                                        "hrec",
                                        {
                                            active: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: CheckboxFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    label: "Active",
                                                },
                                                inputLabel: " ",
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-1",
                                                fieldClassName: "col-sm-11 generic-form-field d-flex align-items-center",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            group: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <div className="form-row d-flex">
                            <div className="col-lg-12 col-xl-6 d-flex flex-column">
                                <h1>Exec</h1>
                                <div className="card card-shadow">
                                    <div className="form-row pt-4 pb-2 px-4">
                                        <div className="col-md-12">
                                            {renderFormControls(
                                                form,
                                                "hrec",
                                                {
                                                    chair: {
                                                        type: RegistrationComponent.RegistrationControl,
                                                        inputType: TextFormInput,
                                                        inputDisabled: formDisabled,
                                                        groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                        labelClassName: "col-form-label col-sm-2",
                                                        fieldClassName: "col-sm-10 generic-form-field",
                                                    },
                                                },
                                                lookups,
                                                validationFailures,
                                                formProperties,
                                                changeForm
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-row pt-2 pb-4 px-4">
                                        <div className="col-sm-11">
                                            {renderFormControls(
                                                form,
                                                "hrec",
                                                {
                                                    administratorId: {
                                                        type: RegistrationComponent.RegistrationControl,
                                                        size: 2,
                                                        inputType: SelectFormInput,
                                                        inputDisabled: formDisabled,
                                                        inputProps: {
                                                            value: form?.administratorId ?? null,
                                                            cacheOptions: true,
                                                            defaultOptions: form?.administrator
                                                                ? [{ label: form.administrator.displayWithSalutation, value: form.administrator.id }]
                                                                : true,
                                                            placeholder: "Type to search for personnel...",
                                                            clearable: true,
                                                            loadOptions: personnelSearchLoader,
                                                        },
                                                        groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                        labelClassName: "col-form-label col-sm-2",
                                                        fieldClassName: "col-sm-10 generic-form-field pl-4 mr-0 pr-0",
                                                    },
                                                },
                                                lookups,
                                                validationFailures,
                                                formProperties,
                                                changeForm
                                            )}
                                        </div>
                                        <div className="col-sm-1 d-flex justify-content-end">
                                            <Button
                                                type="button"
                                                onClick={() => {
                                                    navigate(`/personnel/${form.administratorId}/details`);
                                                }}
                                                disabled={form?.administratorId == null}
                                                style={{
                                                    cursor:
                                                        form?.administratorId == null
                                                            ? "not-allowed"
                                                            : "pointer",
                                                }}
                                            >
                                                <FontAwesomeIcon icon={FontAwesomeIcons.Solid.EYE} />
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <h1>Certification</h1>
                                <div className="card card-shadow">
                                    <div className="form-row pt-4 pb-2 px-4">
                                        <div className="col-sm-12">
                                            {renderFormControls(
                                                form,
                                                "hrec",
                                                {
                                                    nhmrcCertificate: {
                                                        type: RegistrationComponent.RegistrationControl,
                                                        inputType: SelectFormInput,
                                                        inputDisabled: formDisabled,
                                                        inputProps: {
                                                            options:
                                                                generateOptionsFromLookup(
                                                                    findLookup(
                                                                        "Hrec",
                                                                        "NHMRCCertificate",
                                                                        lookups
                                                                    ),
                                                                    form.nhmrcCertificate
                                                                ),
                                                        },
                                                        groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                        labelClassName: "col-form-label col-sm-5",
                                                        fieldClassName: "col-sm-7 generic-form-field",
                                                        inputLabel: "NHMRC Certificate",
                                                    },
                                                },
                                                lookups,
                                                validationFailures,
                                                formProperties,
                                                changeForm
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-row pt-2 pb-4 px-4">
                                        <div className="col-sm-12">
                                            {renderFormControls(
                                                form,
                                                "hrec",
                                                {
                                                    mutualAcceptanceReview: {
                                                        type: RegistrationComponent.RegistrationControl,
                                                        inputType: SelectFormInput,
                                                        inputDisabled: formDisabled,
                                                        inputProps: {
                                                            options:
                                                                generateOptionsFromLookup(
                                                                    findLookup(
                                                                        "Hrec",
                                                                        "NHMRCCertificate",
                                                                        lookups
                                                                    ),
                                                                    form.mutualAcceptanceReview
                                                                ),
                                                        },
                                                        groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                        labelClassName: "col-form-label col-sm-5",
                                                        fieldClassName: "col-sm-7 generic-form-field",
                                                        inputLabel: "National Mutual Acceptance Certified",
                                                    },
                                                },
                                                lookups,
                                                validationFailures,
                                                formProperties,
                                                changeForm
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <h1>Comments</h1>
                                <div className="card card-shadow">
                                    <div className="form-row pt-3 pb-4 px-4">
                                        <div className="col-md-12">
                                            {renderFormControls(
                                                form,
                                                "hrec",
                                                {
                                                    comments: {
                                                        type: RegistrationComponent.RegistrationControl,
                                                        inputType: TextAreaFormInput,
                                                        inputDisabled: formDisabled,
                                                        groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                        labelClassName: "col-sm-0",
                                                        fieldClassName: "col-sm-12 generic-form-field",
                                                        hide: !canViewDetails,
                                                        inputLabel: " ",
                                                    },
                                                },
                                                lookups,
                                                validationFailures,
                                                formProperties,
                                                changeForm
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 col-xl-6 d-flex flex-column">
                                <h1>Trials & Institutions</h1>
                                <div className="card card-shadow scrolly customscrollbar">
                                    <div className="form-row pt-4 px-4 overflow-scroll">
                                        <div className="col-sm-12">
                                            { renderTrialsAndInstitutions }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
        };

        return (
            <Form
                model={reduxFormName}
                onSubmit={(val, _event) => handleOnSubmit(val)}
                onSubmitFailed={(val) => handleOnSubmitFailed(val)}
            >
                {renderFormControls(
                    form,
                    "hrec",
                    formComponents,
                    lookups,
                    validationFailures,
                    formProperties,
                    changeForm
                )}
                <div className="mt-4 mb-4 text-right">
                    <button
                        disabled={formDisabled}
                        onClick={() => {
                            changeForm(`${reduxFormName}.saveAndReturn`, false);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit
                    </button>

                    <button
                        disabled={formDisabled}
                        onClick={() => {
                            changeForm(`${reduxFormName}.saveAndReturn`, true);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit And Return
                    </button>
                    <button
                        onClick={onCancel}
                        className="btn btn-primary mr-2"
                    >
                        Cancel
                    </button>
                </div>
            </Form>
        );
    }, [
        permissions,
        hrecIdNumber,
        savingHrec,
        formState,
        form,
        lookups,
        validationFailures,
        formProperties,
        changeForm,
        personnelSearchLoader,
        navigate,
        generateOptionsFromLookup,
        findLookup,
        renderTrialsAndInstitutions,
        handleOnSubmit,
        handleOnSubmitFailed,
        onCancel,
        reduxFormName
    ]);

    return (
        <RestrictedLayout
            loading={loadingHrec}
            permission={Dtos.Permission.HrecView}
        >
            { renderContent }
        </RestrictedLayout>
    );
};

const mapStateToProps = (state: ITmdState): Partial<HrecPageProps> => {
    let hrec: Dtos.Hrec | undefined = !(state.hrecs.formData instanceof Array)
        ? state.hrecs.formData
        : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];

    return {
        hrec: hrec!,

        loadingHrec:
            state.hrecs.loadState &&
            state.hrecs.loadState.status == RequestState.Pending,
        loadHrecSuccess:
            state.hrecs.loadState &&
            state.hrecs.loadState.status == RequestState.Success,
        loadHrecFailure:
            state.hrecs.loadState &&
            state.hrecs.loadState.status == RequestState.Failure,
        loadHrecErrorCode: state.hrecs.loadState.errorCode,

        savingHrec:
            state.hrecs.saveState &&
            state.hrecs.saveState.status == RequestState.Pending,
        saveHrecSuccess:
            state.hrecs.saveState &&
            state.hrecs.saveState.status == RequestState.Success,
        saveHrecFailure:
            state.hrecs.saveState &&
            state.hrecs.saveState.status == RequestState.Failure,

        creatingHrec:
            state.hrecs.createState &&
            state.hrecs.createState.status == RequestState.Pending,
        createHrecSuccess:
            state.hrecs.createState &&
            state.hrecs.createState.status == RequestState.Success,
        createHrecFailure:
            state.hrecs.createState &&
            state.hrecs.createState.status == RequestState.Failure,

        validatingHrec:
            state.hrecs.validateState &&
            state.hrecs.validateState.status == RequestState.Pending,

        permissions: permissions,
        lookups: state.hrecs.lookups,

        form: state.reduxForms.hrec,
        formState: state.hrecs.formState,
        formProperties: state.hrecs.formProperties,

        reduxFormState: state.reduxForms.formState.hrec,
        validationFailures: hrec ? state.hrecs.validationFailures : undefined,

        toggleItems: state.togglePage.items,

        trials: state.trials.formFilteredData!,
        loadingTrials:
            state.trials.loadState &&
            state.trials.loadState.status == RequestState.Pending,
        loadTrialsFailure:
            state.trials.loadState &&
            state.trials.loadState.status == RequestState.Failure,
        loadTrialsErrorCode: state.trials.loadState.errorCode,

        institutions: state.institutions.formFilteredData!,
        loadingInstitutions:
            state.institutions.loadState &&
            state.institutions.loadState.status == RequestState.Pending,
        loadInstitutionsFailure:
            state.institutions.loadState &&
            state.institutions.loadState.status == RequestState.Failure,
        loadInstitutionsErrorCode: state.institutions.loadState.errorCode,
    };
};

const mapDispatchToProps = (dispatch): Partial<HrecPageProps> => {
    return {
        loadHrec: bindActionCreators(HrecActions.LoadHrecById, dispatch),
        clearHrec: bindActionCreators(HrecActions.Clear, dispatch),

        saveHrec: bindActionCreators(HrecActions.SaveHrec, dispatch),
        createHrec: bindActionCreators(HrecActions.CreateHrec, dispatch),
        validateHrec: bindActionCreators(HrecActions.ValidateHrec, dispatch),

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        setBreadcrumbs: bindActionCreators(NavigationActions.SetBreadcrumbs, dispatch),
        setDrawerItems: bindActionCreators(NavigationActions.SetDrawerItems, dispatch),

        toggleExpand: bindActionCreators(ToggleActions.ToggleExpanded, dispatch),

        loadTrials: bindActionCreators(TrialActions.LoadTrial, dispatch),
        clearTrials: bindActionCreators(TrialActions.Clear, dispatch),

        loadInstitutions: bindActionCreators(InstitutionActions.LoadInstitution, dispatch),
        clearInstitutions: bindActionCreators(InstitutionActions.Clear, dispatch)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HrecPage);
